import { CameraControls } from '@react-three/drei';
import { useThree } from '@react-three/fiber';
import { RefObject, useEffect } from 'react';

import { AnimationPlayerStoreInstance } from 'stores/animationPlayerStoreFactory';

import { DEFAULT_LOOK_AT_POSITION } from './SceneSetup';

export default function MiniCameraControls({
  animationPlayerStore,
  cameraControlsRef,
  defaultPosition,
}: {
  animationPlayerStore: AnimationPlayerStoreInstance;
  defaultPosition: number[];
  cameraControlsRef: RefObject<CameraControls | null>;
}) {
  const { camera } = useThree();

  useEffect(() => {
    if (cameraControlsRef.current) {
      animationPlayerStore.setCameraControl(cameraControlsRef.current);
      cameraControlsRef.current.setLookAt(
        defaultPosition[0],
        defaultPosition[1],
        defaultPosition[2],
        DEFAULT_LOOK_AT_POSITION[0],
        DEFAULT_LOOK_AT_POSITION[1],
        DEFAULT_LOOK_AT_POSITION[2],
        true,
      );
    }
  }, [animationPlayerStore, camera, cameraControlsRef]);

  return <CameraControls ref={cameraControlsRef} />;
}
